module.exports = __webpack_public_path__ + "static/media/correct-tone.feb29173.wav";